import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "../services/authentication.service";
import * as sha256 from "sha256";
import { Router } from "@angular/router";
import { LoginRequest, DeviceInfo } from "../models/account";
import * as firebase from "firebase";
// import { MessagingService } from '../services/messaging.service';
import { DomSanitizer } from "@angular/platform-browser";
import { DeviceDetectorService } from "ngx-device-detector";

declare var $: any;

@Component({
  selector: "app-login-dialog",
  templateUrl: "./login-dialog.component.html",
  styleUrls: ["./login-dialog.component.css"],
})
export class LoginDialogComponent implements OnInit {
  public visible = false;
  private visibleAnimate = false;
  public isLoginOpen = true;
  public username: "";
  public password: "";
  public isAgree = false;
  public errMessage = "";
  public modalLogin = "modal-login";

  fieldTextType = false;
  modalConsent = "modal-consent";
  rememberMe = false;
  userConsent = false;

  userConsentWording = null;
  viewTitle: any;
  viewContent: any;

  deviceInfo = null;
  device = new DeviceInfo();

  isDisableButton = false;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private deviceService: DeviceDetectorService
  ) {
    this.getDeviceInfo();
  }

  ngOnInit() {
    this.getUserConsentWording();
  }

  getDeviceInfo(): void {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isDesktop = this.deviceService.isDesktop();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isDesktop) {
      this.device.deviceType = "Desktop";
      this.device.webType = "Web Desktop";
    } else if (isMobile) {
      this.device.deviceType = "Mobile";
      this.device.webType = "Web Mobile";
    } else if (isTablet) {
      this.device.deviceType = "Tablet";
      this.device.webType = "Web Tablet";
    }

    this.device.os = this.deviceInfo.os;
  }

  public login() {
    firebase.analytics().logEvent("login_button");
    this.errMessage = "";
    const device = this.device.deviceType;
    const web = this.device.webType;
    const os = this.device.os;

    const loginReq = new LoginRequest();
    loginReq.username = this.username;
    loginReq.password = sha256(this.password);
    // loginReq.password = this.password;
    loginReq.ApprovalConsent = this.userConsent;
    loginReq.device = device + ", " + web + ", " + os;

    if (this.isAgree) {
      this.isDisableButton = true;
      this.authService.login(
        loginReq,
        (data) => {
          this.isDisableButton = false;
          $("#" + this.modalLogin).modal("hide");
          this.router.navigate(["/dashboard"]);
          //this.messagingService.getPermission();
          // this.updateToken();
        },
        (err) => {
          this.isDisableButton = false;
          this.authService.logout();
          this.errMessage = err.message;
        }
      );
    } else this.errMessage = "Syarat dan Ketentuan harus dicentang";
  }

  // updateToken() {
  //   this.messagingService.updateToken((data) => {
  //   },
  //     err => {
  //       this.authService.logout();
  //       this.errMessage = err.message;
  //     });
  // }

  public show(): void {
    $("#" + this.modalLogin).modal("show");
  }

  public hide(): void {
    $("#" + this.modalLogin).modal("hide");
  }

  public openLogin(): void {
    if (this.isLoginOpen) {
      this.isLoginOpen = false;
    } else {
      this.isLoginOpen = true;
    }
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }

  public openPage() {
    firebase.analytics().logEvent("toc_button");

    this.router.navigate([]).then((result) => {
      window.open("terms", "_blank");
    });
  }

  public goToForgot() {
    firebase.analytics().logEvent("lupa_password_button");

    $("#" + this.modalLogin).modal("hide");
    this.router.navigate(["/account/forgotpassword"]);
  }

  public goToRegister() {
    firebase.analytics().logEvent("register_button");

    $("#" + this.modalLogin).modal("hide");
    this.router.navigate(["/register"]);
  }

  public toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  public onRememberMeChanged(event): void {
    this.userConsent = event;

    if (event) {
      this.hide();
      $("#" + this.modalConsent).modal("show");
    }
  }

  public onAgreeConsent(): void {
    this.userConsent = true;
    this.rememberMe = true;
    $("#" + this.modalConsent).modal("hide");
    this.show();
  }

  public onNotAgreeConsent(): void {
    this.userConsent = false;
    this.rememberMe = false;
    $("#" + this.modalConsent).modal("hide");
    this.show();
  }

  public getUserConsentWording(): void {
    this.authService.getUserConsentWording((response) => {
      this.userConsentWording = response;

      this.viewTitle = this.sanitizer.bypassSecurityTrustHtml(
        this.userConsentWording.title
      );
      this.viewContent = this.sanitizer.bypassSecurityTrustHtml(
        this.userConsentWording.consent
      );
    });
  }
}
